module.exports = __webpack_public_path__ + "static/media/instrucciones.3575e901.mp3";